import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Client } from './types'

export const CREATE_CLIENT: TypedDocumentNode<
  { createClient: Client },
  { name: string; path: string; observations?: string | null }
> = gql`
  mutation CreateClient($name: String!, $path: String!, $observations: String) {
    createClient(name: $name, path: $path, observations: $observations) {
      id name path blocked observations created_at updated_at
    }
  }
`

export const UPDATE_CLIENT: TypedDocumentNode<
  { updateClient: Client },
  { id: string; name?: string; path?: string; observations?: string | null }
> = gql`
  mutation UpdateClient($id: ID!, $name: String, $path: String, $observations: String) {
    updateClient(id: $id, name: $name, path: $path, observations: $observations) {
      id name path blocked observations created_at updated_at
    }
  }
`

export const BLOCK_CLIENT: TypedDocumentNode<{ blockClient: Client }, { id: string }> = gql`
  mutation BlockClient($id: ID!) {
    blockClient(id: $id) {
      id name path blocked observations created_at updated_at
    }
  }
`
